var r=function(r,t){return r===t||r!=r&&t!=t};export{r as default};
//# sourceMappingURL=eq.js.map
